// extracted by mini-css-extract-plugin
export default {"editor":"CvEditor_editor__BN3dg"};